"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: Object.getOwnPropertyDescriptor(all, name).get
    });
}
_export(exports, {
    get addDaysInTimezone () {
        return addDaysInTimezone;
    },
    get addMonthsInTimezone () {
        return addMonthsInTimezone;
    },
    get addYearsInTimezone () {
        return addYearsInTimezone;
    },
    get convertToLocalZonedTime () {
        return convertToLocalZonedTime;
    },
    get convertToZonedUTCTime () {
        return convertToZonedUTCTime;
    },
    get differenceInCalendarDaysInTimezone () {
        return differenceInCalendarDaysInTimezone;
    },
    get differenceInDaysInTimezone () {
        return differenceInDaysInTimezone;
    },
    get formatDateAsUTCString () {
        return formatDateAsUTCString;
    },
    get isValidIanaTimezone () {
        return isValidIanaTimezone;
    },
    get setDateToTimeOfDateWithTimezone () {
        return setDateToTimeOfDateWithTimezone;
    },
    get setTimeOfDateInTimezone () {
        return setTimeOfDateInTimezone;
    }
});
const _datefns = require("date-fns");
const _datefnstz = require("date-fns-tz");
const _constants = require("../constants");
const isValidIanaTimezone = (timezone)=>{
    if (!timezone || typeof timezone !== "string" || timezone.trim().length === 0) {
        return false;
    }
    try {
        // Throws RangeError on unrecognized tz strings
        new Intl.DateTimeFormat("en-US", {
            timeZone: timezone
        });
        return true;
    } catch  {
        return false;
    }
};
const convertToZonedUTCTime = (dateToConvert, timezone)=>{
    return (0, _datefnstz.zonedTimeToUtc)(dateToConvert, timezone);
};
const convertToLocalZonedTime = (dateToConvert, timezone)=>{
    return (0, _datefnstz.utcToZonedTime)(dateToConvert, timezone);
};
const setDateToTimeOfDateWithTimezone = ({ date, time, timezone = _constants.DEFAULT_TIMEZONE })=>{
    const dateInTz = (0, _datefnstz.utcToZonedTime)(date, timezone);
    const timeInTz = (0, _datefnstz.utcToZonedTime)(time, timezone);
    dateInTz.setHours(timeInTz.getHours());
    dateInTz.setMinutes(timeInTz.getMinutes());
    dateInTz.setSeconds(timeInTz.getSeconds());
    dateInTz.setMilliseconds(timeInTz.getMilliseconds());
    return (0, _datefnstz.zonedTimeToUtc)(dateInTz, timezone);
};
const setTimeOfDateInTimezone = ({ date, hours = 0, minutes = 0, seconds = 0, milliseconds = 0, timezone = _constants.DEFAULT_TIMEZONE })=>{
    const dateInTz = (0, _datefnstz.utcToZonedTime)(date, timezone);
    dateInTz.setHours(hours);
    dateInTz.setMinutes(minutes);
    dateInTz.setSeconds(seconds);
    dateInTz.setMilliseconds(milliseconds);
    return (0, _datefnstz.zonedTimeToUtc)(dateInTz, timezone);
};
const addDaysInTimezone = ({ date, days, timezone = _constants.DEFAULT_TIMEZONE })=>{
    // Convert the provided UTC date to the timezone
    // Returns a UTC date but with the timezone offset
    const zonedDate = (0, _datefnstz.utcToZonedTime)(date, timezone);
    // Add days
    const newZonedDate = (0, _datefns.addDays)(zonedDate, days);
    // Convert back to real UTC, accounting for timezone offset
    return (0, _datefnstz.zonedTimeToUtc)(newZonedDate, timezone);
};
const addMonthsInTimezone = ({ date, months, timezone = _constants.DEFAULT_TIMEZONE })=>{
    // Convert the provided UTC date to the timezone
    // Returns a UTC date but with the timezone offset
    const zonedDate = (0, _datefnstz.utcToZonedTime)(date, timezone);
    // Add months
    const newZonedDate = (0, _datefns.addMonths)(zonedDate, months);
    // Convert back to real UTC, accounting for timezone offset
    return (0, _datefnstz.zonedTimeToUtc)(newZonedDate, timezone);
};
const addYearsInTimezone = ({ date, years, timezone = _constants.DEFAULT_TIMEZONE })=>{
    // Convert the provided UTC date to the timezone
    // Returns a UTC date but with the timezone offset
    const zonedDate = (0, _datefnstz.utcToZonedTime)(date, timezone);
    // Add years
    const newZonedDate = (0, _datefns.addYears)(zonedDate, years);
    // Convert back to real UTC, accounting for timezone offset
    return (0, _datefnstz.zonedTimeToUtc)(newZonedDate, timezone);
};
const formatDateAsUTCString = (date)=>{
    return (0, _datefnstz.formatInTimeZone)(date, "UTC", "MMMM d, yyyy");
};
const differenceInDaysInTimezone = ({ firstDate, secondDate, timezone = _constants.DEFAULT_TIMEZONE })=>{
    // Convert the provided UTC date to the timezone
    // Returns a UTC date but with the timezone offset
    const zonedFirstDate = (0, _datefnstz.utcToZonedTime)(firstDate, timezone);
    const zonedSecondDate = (0, _datefnstz.utcToZonedTime)(secondDate, timezone);
    return (0, _datefns.differenceInDays)(zonedFirstDate, zonedSecondDate);
};
const differenceInCalendarDaysInTimezone = ({ firstDate, secondDate, timezone = _constants.DEFAULT_TIMEZONE })=>{
    const zonedFirstDate = (0, _datefnstz.utcToZonedTime)(firstDate, timezone);
    const zonedSecondDate = (0, _datefnstz.utcToZonedTime)(secondDate, timezone);
    return (0, _datefns.differenceInCalendarDays)(zonedFirstDate, zonedSecondDate);
};
